class AddEditUserActionsModalController {
    constructor() {
        // this.userId = this.resolve.userId;
        // this.buId = this.resolve.buId;
        // this.isCorporate = this.resolve.isCorporate;
    }
    $onInit() {
        this.userId = this.resolve.userId;
        this.buId = this.resolve.buId;
        this.isCorporate = this.resolve.isCorporate;
        if (this.isCorporate) {
            this.clientOrBuLabel = "BU";
        }
        else {
            this.clientOrBuLabel = "Client";
        }
        this.callbackObject = { callbackType: 'cancel', entity: {} };
    }
    closeModal() {
        this.modalInstance.close(this.callbackObject);
    }
    dismissModal() {
        this.modalInstance.dismiss('cancel');
    }
}
// import * as TEMPLATE from './add-edit-user-actions-modal.html';
import * as TEMPLATE from 'raw-loader!./add-edit-user-actions-modal.html';
export const AddEditUserActionsModalComponent = {
    selector: 'addEditUserActionsModal',
    component: {
        bindings: {
            modalInstance: "<",
            resolve: "<"
        },
        controller: AddEditUserActionsModalController,
        template: TEMPLATE.default
        // templateUrl: 'app/partials/missioncontrol/addEditUser/addEditUserActionsModal/add-edit-user-actions-modal.html'
    }
};
//# sourceMappingURL=add-edit-user-actions.component.js.map